import { create } from 'zustand';

/**
 * 收号信息抽屉开关（工作台右滑抽屉，内容 = 原左栏「收号信息」卡）。
 *
 * 卡里有 PII（客户报的身份证后 4 位、联系电话等），不常显在工作台左栏；顶栏「收号」入口下发字段后，
 * 需要看客户已提交的值时从这里展开。开关只活在内存（不落 localStorage）：刷新或换号即收起，
 * 避免一台机器上换个工号接着看上一通/上一人的收号。
 */
interface CollectDrawerStore {
  /** 收号信息抽屉是否展开 */
  drawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  /** 登出/换号时复位 */
  reset: () => void;
}

export const useCollectGate = create<CollectDrawerStore>((set) => ({
  drawerOpen: false,
  openDrawer: () => set({ drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false }),
  reset: () => set({ drawerOpen: false }),
}));
